module.exports = __webpack_public_path__ + "img/制御工学6_4.9735ec2e.png";